import { useAuthStore } from '@/stores/auth.store'
import type { UserRole } from '@/types'

const ROLE_HIERARCHY: Record<UserRole, number> = {
  SUPER_ADMIN: 7,
  ADMIN:       6,
  MANAGER:     5,
  ANALYST:     4,
  AUDITOR:     3,
  CLIENT:      2,
  VIEWER:      1,
}

export function usePermissions() {
  const user = useAuthStore((s) => s.user)

  const hasRole = (role: UserRole): boolean => {
    if (!user) return false
    return ROLE_HIERARCHY[user.role] >= ROLE_HIERARCHY[role]
  }

  const isAdmin = hasRole('ADMIN')
  const isSuperAdmin = hasRole('SUPER_ADMIN')
  const isManager = hasRole('MANAGER')
  const isAnalyst = hasRole('ANALYST')

  return { hasRole, isAdmin, isSuperAdmin, isManager, isAnalyst, user }
}
